package org.junqueira.portfolio.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.junqueira.portfolio.data.Strings

@Composable
fun BottomBar(
    modifier: Modifier = Modifier,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
            .fillMaxWidth()
            .wrapContentHeight(),
    ) {
        HorizontalDivider(
            color = Color.Gray,
            thickness = 2.dp,
        )
        Text(
            text = Strings.copyright,
            modifier = Modifier
                .padding(vertical = 16.dp)
        )
    }
}